import "bootstrap-sass";
import "readmore-js";
import {
    screenSizes,
} from "./config";

export const toggle = {
    init: function () {
        // Close collapse on click
        $('.btn-more[aria-expanded="true"]').text('LESS');

        // Toggle long text for Read More
        toggle.toggleText();

        // Toggle long element
        toggle.toggleElement();
    },

    toggleText: function () {
        if ($(window).width() < screenSizes.small - 1) {
            $('.toggle-text').readmore({
                startOpen: false,
                moreLink: '<a href="#"><div class="line-separator"><div class="side-line"></div><div class="triangle bottom"> </div><div class="side-line"> </div></div></a>',
                lessLink: '<a href="#"><div class="line-separator"><div class="side-line"></div><div class="triangle top"> </div><div class="side-line"> </div></div></a>',
            });
        } else {
            $('.toggle-text').readmore('destroy');
        }
    },

    toggleElement: function () {
        $('.toggle-element').readmore({
            startOpen: false,
            moreLink: '<div class="text-center"><a class="btn btn-white" role="button" href="#">More</a></div>',
            lessLink: '<div class="text-center"><a class="btn btn-white" role="button" href="#">Less</a></div>',
        });
    },
};
